// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"56":"politica","486":"bcompliance","915":"empresas"}[chunkId] + "." + {"56":"5474762a","486":"91c53960","915":"85ee9d02"}[chunkId] + ".css";
};